/* eslint-disable no-return-assign */
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../actions';

function ViewTransmittalModal({ data }) {
  const setModal = useContext(ModalContext);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Generated Transmittal"
                  src={data?.res?.url || ''}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewTransmittalModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewTransmittalModal);
